import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Movements = lazy(() => import('./Movements'));
const MovementsHistory = lazy(() => import('./MovementsHistory'));

// Export both canonical and alias routes + history route in one file
const MovementsRoutes: FuseRouteItemType[] = [
	{
		path: '/equipment-movements',
		element: <Movements />
	},
	{
		// History/audit trail for movements
		path: '/equipment-movements-history',
		element: <MovementsHistory />
	}
];

export default MovementsRoutes;
